import MainLayout from "../layouts/MainLayout";
import "../assets/styles/NotFound.css";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
const NotFound = () => {
  const navigate = useNavigate();

  return (
    <MainLayout selectedCompany="ALUCOM">
      <Box className="error-page" sx={{ height: "100%" }}>
        <Box className="content-error">
          <Typography variant="h1">404</Typography>
          <Typography variant="h4">Opps! Página não encontrada</Typography>
          <Typography variant="body1">
            Parece que você se perdeu ou a página que está procurando não
            existe. Se você acredita que isso é um erro ou precisa de ajuda,
            entre em contato conosco.
          </Typography>
          <Box className="btns-error">
            {/* retornar para pagina anterior */}
            <Button
              variant="outlined"
              color="error"
              size="large"
              sx={{ borderRadius: "22px" }}
              href={() => navigate(-1)}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => navigate(-1)}
            >
              Retornar
            </Button>
            {/* reportar problema */}
            <Button
              variant="outlined"
              color="error"
              size="large"
              sx={{ borderRadius: "22px" }}
              href="https://wa.me/5585989724339?text=Olá!%20Tenho%20uma%20dúvida."
              target="_blank"
              rel="noopener noreferrer"
            >
              Reportar problema
            </Button>
          </Box>
        </Box>
      </Box>
    </MainLayout>
  );
};

export default NotFound;
